import { render, staticRenderFns } from "./TestpaperList.vue?vue&type=template&id=10e565f6&"
import script from "./TestpaperList.vue?vue&type=script&lang=js&"
export * from "./TestpaperList.vue?vue&type=script&lang=js&"
import style0 from "./TestpaperList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports